module.exports = __webpack_public_path__ + "img/sun-set.246410b9.svg";